import React, { useState, useEffect } from "react";
import {
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  useTheme,
  IconButton,
  styled,
  Stack,
  Button,
  TextField,
} from "@mui/material";
import { Close } from "@mui/icons-material";

const CustomDialog = styled(Dialog)(() => ({
  "& .MuiDialog-paper": {
    backgroundColor: "rgb(255,255,255)",
    borderRadius: "1rem",
    border: "1px solid lightgrey",
  },
}));

const ModalAlasanMundur = ({ open, onClose, onSubmit, loading }) => {
  useTheme();

  const [reason, setReason] = useState("");
  const [error, setError] = useState(false);

  // Reset form tiap modal dibuka/tutup
  useEffect(() => {
    if (!open) {
      setReason("");
      setError(false);
    }
  }, [open]);

  const handleSubmit = () => {
    if (!reason.trim()) {
      setError(true);
      return;
    }
    onSubmit(reason.trim());
  };

  return (
    <CustomDialog open={open} maxWidth="xs" fullWidth>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems="center"
      >
        <DialogTitle>
          <b>Konfirmasi Pengunduran Diri</b>
        </DialogTitle>
        <IconButton sx={{ mr: "1rem" }} onClick={onClose}>
          <Close />
        </IconButton>
      </Stack>

      <DialogContent dividers>
        <Stack spacing={2}>
          <Typography variant="body2">
            Mohon sampaikan alasan Anda mengundurkan diri dari proses ini.
            Informasi ini akan digunakan sebagai catatan internal perusahaan.
          </Typography>

          <TextField
            label="Alasan Mengundurkan Diri"
            placeholder="Tuliskan alasan Anda di sini..."
            multiline
            minRows={4}
            fullWidth
            value={reason}
            onChange={(e) => {
              setReason(e.target.value);
              if (error) setError(false);
            }}
            error={error}
            helperText={error ? "Alasan wajib diisi." : ""}
          />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={onClose} disabled={loading}>
          Batal
        </Button>
        <Button variant="contained" onClick={handleSubmit} disabled={loading}>
          Kirim & Mengundurkan Diri
        </Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default ModalAlasanMundur;
